// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserMenu-module__accountMenu__rKkZR {
  border-radius: 2px;
  background: #303048;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  transition: none !important;
}
.UserMenu-module__accountMenu__rKkZR .ant-menu-light {
  border-radius: 2px;
  background: #303048;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
}
.UserMenu-module__accountMenu__rKkZR .ant-menu-title-content {
  color: var(--cool-grey-5, #c2c2d0);
  /* Footnote/description */
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 166.667% */
}
.UserMenu-module__accountMenu__rKkZR .ant-menu-item {
  margin: 2px 0;
  height: 28px;
  width: 100%;
  border-radius: 0;
  display: flex;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
}
.UserMenu-module__accountMenu__rKkZR .ant-menu-item:active {
  background-color: #595973 !important;
  outline: none;
}
.UserMenu-module__accountMenu__rKkZR .ant-menu-item:hover {
  background-color: #595973 !important;
  outline: none;
  color: #e5e5eb;
}
.UserMenu-module__header__Rrl1O {
  padding: 8px 10px;
  display: grid;
  grid-template-columns: 18px 1fr;
  grid-gap: 8px;
  align-items: center;
  color: var(--cool-grey-5, #c2c2d0);
  border: 1px solid #797993;
  font-size: 12px;
}
.UserMenu-module__header__Rrl1O .ant-avatar {
  margin-right: 10px;
}
.UserMenu-module__logout__DT9AP {
  border-top: 1px solid #797993;
  border-radius: 0 !important;
  margin-bottom: 8px !important;
  height: 36px;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserMenu/UserMenu.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,2BAAA;AACF;AALA;EAMI,kBAAA;EACA,mBAAA;EACA,+CAAA;AAEJ;AAVA;EAWI,kCAAA;EAEF,yBAAyB;EACvB,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACF,aAAa;AACf;AApBA;EAsBI,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AACJ;AA9BA;EAiCI,oCAAA;EACA,aAAA;AAAJ;AAlCA;EAsCI,oCAAA;EACA,aAAA;EACA,cAAA;AADJ;AAIA;EACE,iBAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,yBAAA;EACA,eAAA;AAFF;AANA;EAUI,kBAAA;AADJ;AAKA;EACE,6BAAA;EACA,2BAAA;EACA,6BAAA;EACA,YAAA;AAHF","sourcesContent":[".accountMenu {\n  border-radius: 2px;\n  background: #303048;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);\n  transition: none !important;\n  :global(.ant-menu-light) {\n    border-radius: 2px;\n    background: #303048;\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);\n  }\n  :global(.ant-menu-title-content) {\n    color: var(--cool-grey-5, #c2c2d0);\n\n    /* Footnote/description */\n    font-family: Nunito;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 166.667% */\n  }\n\n  :global(.ant-menu-item) {\n    margin: 2px 0;\n    height: 28px;\n    width: 100%;\n    border-radius: 0;\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    cursor: pointer;\n  }\n\n  :global(.ant-menu-item:active) {\n    background-color: #595973 !important;\n    outline: none;\n  }\n\n  :global(.ant-menu-item:hover) {\n    background-color: #595973 !important;\n    outline: none;\n    color: #e5e5eb;\n  }\n}\n.header {\n  padding: 8px 10px;\n  display: grid;\n  grid-template-columns: 18px 1fr;\n  grid-gap: 8px;\n  align-items: center;\n  color: var(--cool-grey-5, #c2c2d0);\n  border: 1px solid #797993;\n  font-size: 12px;\n  :global(.ant-avatar) {\n    margin-right: 10px;\n  }\n}\n\n.logout {\n  border-top: 1px solid #797993;\n  border-radius: 0 !important;\n  margin-bottom: 8px !important;\n  height: 36px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accountMenu": `UserMenu-module__accountMenu__rKkZR`,
	"header": `UserMenu-module__header__Rrl1O`,
	"logout": `UserMenu-module__logout__DT9AP`
};
export default ___CSS_LOADER_EXPORT___;
